import React, { useEffect, useState } from 'react';
import { useI18n } from '../i18n/I18nProvider';
import { fetchStudies } from '../lib/content';
import { StudyCard, SeriesBlock } from './StudyCards';

function groupSeries(items) {
  const series = {};
  const single = [];
  items.forEach((s) => (s.series ? (series[s.series] = series[s.series] || []).push(s) : single.push(s)));
  return { series: Object.entries(series), single };
}

export default function BibleStudies() {
  const { lang } = useI18n();
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const data = await fetchStudies();
        setItems(data.items || []);
      } catch (err) { console.error('Failed to load studies', err); }
      setLoaded(true);
    })();
  }, []);

  const copy = lang === 'es'
    ? {
        eyebrow: 'Estudios B\u00edblicos',
        title_1: 'Profundiza en', title_2: 'la Palabra.',
        sub: 'Descarga las gu\u00edas de estudio del Pastor Greg para ir m\u00e1s a fondo en el pasaje de cada semana.',
        empty: 'Pronto compartiremos nuevos estudios aqu\u00ed. Vuelve pronto.',
        open: 'Abrir PDF', download: 'Descargar',
        series: 'Serie', available: 'disponibles', session: 'Sesión', progress: 'Progreso de la serie',
        soon: 'Próximamente', soonText: 'Esta sesión llegará pronto. Vuelve la próxima semana.', more: 'Más estudios',
      }
    : {
        eyebrow: 'Bible Studies',
        title_1: 'Go deeper', title_2: 'in the Word.',
        sub: "Download Pastor Greg's study guides to dig deeper into each week's passage on your own or in a group.",
        empty: "New studies are coming soon. Check back shortly.",
        open: 'Open PDF', download: 'Download',
        series: 'Series', available: 'available', session: 'Session', progress: 'Series progress',
        soon: 'Coming soon', soonText: 'This session is on its way. Check back next week.', more: 'More studies',
      };

  const groups = groupSeries(items);

  if (loaded && items.length === 0) {
    return (
      <section id="studies" className="relative py-20 lg:py-24 bg-[#efe6cf]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center">
          <span className="text-[#b88a2a] text-xs uppercase tracking-wider-xtra font-medium">{copy.eyebrow}</span>
          <h2 className="font-serif-display text-4xl md:text-5xl text-[#1f3a2a] mt-4">{copy.title_1} <span className="italic">{copy.title_2}</span></h2>
          <p className="mt-6 text-[#4a5a4e] text-base max-w-xl mx-auto">{copy.empty}</p>
        </div>
      </section>
    );
  }

  return (
    <section id="studies" className="relative py-24 lg:py-32 bg-[#efe6cf]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <span className="text-[#b88a2a] text-xs uppercase tracking-wider-xtra font-medium">{copy.eyebrow}</span>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#1f3a2a] mt-4 leading-[1.05]">
            {copy.title_1} <span className="italic">{copy.title_2}</span>
          </h2>
          <p className="mt-6 text-[#4a5a4e] text-lg leading-relaxed">{copy.sub}</p>
        </div>

        {groups.series.map(([name, list]) => (
          <SeriesBlock key={name} name={name} total={Math.max(...list.map((x) => x.series_total || 0))} items={list} copy={copy} />
        ))}

        {groups.single.length > 0 && (
          <div className="mt-14">
            {groups.series.length > 0 && <h3 className="font-serif-display text-2xl text-[#1f3a2a]">{copy.more}</h3>}
            <div className="mt-6 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
              {groups.single.map((s) => <StudyCard key={s.id} s={s} copy={copy} />)}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
